mod.modules.define("Plugin-Paging", function(fn) {

	fn.prototype.events = {
		".pager-wrap [data-pageindex]:not([disabled=disabled])": {
			"click": function(e, $el) {
				this.reload({
					PageIndex: $el.attr("data-pageindex")
				});
			}
		},
		".pager-wrap select.pager-select-page": {
			"change": function(e, $el) {
				this.reload({
					PageIndex: $el.val()
				});
			}
		}
	};

});